import { fetchAuthSession, getCurrentUser } from 'aws-amplify/auth';

export const isAuthenticated = async () => {
  try {
    await fetchAuthSession();
    return true;
  } catch (err) {
    return false;
  }
};

export const currentAuthenticatedUser = async () => {
  try {
    const { username } = await getCurrentUser();
    return username;
  } catch {
    return null;
  }
}
